import React from 'react';
import ReactDOM from 'react-dom';
import SegmentMiddleware from '@/Analytics/Segment/middleware';
import App from './App';
import APMAgent from './Utils/APMAgent';
import { initPAL } from './Utils/InitPal';
import Sentry from './Utils/Sentry';
import { generateUnifiedSessionId } from './Providers/BrowserSessionProvider';
// import * as serviceWorker from './serviceWorker';

generateUnifiedSessionId();
APMAgent.init();
Sentry.init();
SegmentMiddleware.init();
initPAL();
ReactDOM.render(<App />, document.getElementById('app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
